// @ts-strict-ignore
import type { Taxonomy } from "@shared/types/graphqlGenerated";

const flattenChildren = arr => {
  if (!arr?.length) return [];

  return arr.flatMap(({ children, ...o }) => [o, ...flattenChildren(children)]);
};

export const hasAnyActiveChild = (taxonomy: Taxonomy, activeTaxonomyIds: string[]) => {
  if (activeTaxonomyIds.length === 0 || taxonomy.children?.length === 0) {
    return false;
  }

  return activeTaxonomyIds.some(ids =>
    flattenChildren(taxonomy.children)
      .map(({ id }) => id)
      .includes(ids)
  );
};
